import { BrowserIcon } from 'assets/images';
import { translate } from 'store/modules/base/i18n';
import { connect } from 'store/modules/base/redux';
import { updateSleepSettings } from 'store/modules/settings';
import { hideDialog, openDialog } from 'store/modules/base/dialog';
import React from 'react';
import AbstractButton from './AbstractButton';
import VWBrowser from '../Browser/VWBrowser';
import withBoundary from 'component/ErrorBoundary/withBoundary';

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractButton
 */
class BrowserButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.browser';
  label = 'toolbar.browser';
  type = 'darkblue';
  icon = BrowserIcon;

  /**
   * Initializes a new HangupButton instance.
   *
   * @param {Props} props - The read-only properties with which the new
   * instance is to be initialized.
   */
  constructor(props) {
    super(props);
    if (props.options && props.options.buttonName !== '')
      this.label = props.options.buttonName;
  }

  /**
   * Handles clicking / pressing the button, and disconnects the conference.
   *
   * @protected
   * @returns {void}
   */
  _handleClick() {
    const toggled = this._isToggled();
    const options = this.props.options;
    this.props.dispatch(
      updateSleepSettings({
        userBrowserMode: !toggled,
        browserOptions: options
      })
    );
    if (options.browserStyle !== 'side-by-side') {
      if (toggled) this.props.dispatch(hideDialog('Browser'));
      else this.props.dispatch(openDialog(VWBrowser, 'Browser', { options }));
    }
  }

  /**
   * Indicates whether this button is in toggled state or not.
   *
   * @override
   * @protected
   * @returns {boolean}
   */
  _isToggled() {
    return this.props.browserMode;
  }
}

/**
 * Maps (parts of) the Redux state to the associated {@code HangupButton}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The own props of the component.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
  return {
    browserMode: state['features/settings'].userBrowserMode,
    _userIdleMode: state['features/settings'].userIdleMode
  };
}
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(BrowserButton)))
);
